module.exports = __webpack_public_path__ + "img/sepa.de0d5bd2.png";